// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","box":"Footer_box__w3eRK","social":"Footer_social__1qlfP"};